import { createApp } from "vue";
import ElementPlus from "element-plus";
import "element-plus/dist/index.css";
import "element-plus/theme-chalk/display.css";
import locale from "element-plus/dist/locale/zh-cn.mjs";
import App from "./App.vue";
import "vxe-table/lib/style.css";
import utils from "@/utils/index";
import httpRequest from "@/utils/request";
import components from "./components";
import router from "./router";
import store from "./store";
import lodash from "lodash/object";
import VueClipboard from "vue-clipboard2";
import VueCookies from "vue-cookies";
import vue3TreeOrg from 'vue3-tree-org';
import "vue3-tree-org/lib/vue3-tree-org.css";
const app = createApp(App);
import print from 'vue3-print-nb'
app.config.globalProperties.hasPermission = utils.hasPermission; // 权限方法
app.config.globalProperties.treeDataTranslate = utils.treeDataTranslate; // 树形数据转换
app.config.globalProperties.$utils = utils;
app.config.globalProperties.$t2 = utils.t2;
app.config.globalProperties.$window = window;
app.config.globalProperties.recover = utils.recover;
app.config.globalProperties.recoverNotNull = utils.recoverNotNull;
app.config.globalProperties.pickProperties = utils.pickProperties;
app.config.globalProperties.lodash = lodash;
app.config.globalProperties.deepClone = utils.deepClone;
app.config.globalProperties.validatenull = utils.validatenull;
app.config.globalProperties.$http = httpRequest; // ajax请求方法
app.config.globalProperties.$cookies = VueCookies;
app.use(vue3TreeOrg)
app.use(store);
app.use(router);
app.use(ElementPlus, { locale });
app.use(components);
app.use(VueClipboard);
app.use(VueCookies);
app.use(print)
//挂载app
app.mount("#app");



